
	frappe.templates['desktop_icon'] = `<a class="desktop-icon" data-id="{{ icon.label}}"  data-logo="{{ icon.logo_url }}" data-icon="{{ icon.icon }}" data-type="{{ icon.type }}" style="text-decoration:none">
    {% if(frappe.utils.get_desktop_icon(icon.label, frappe.boot.desktop_icon_style ) && icon.icon_type != "Folder") %}
        <div class="icon-container">
            <img class="app-icon" src="{{ frappe.utils.get_desktop_icon(icon.label, frappe.boot.desktop_icon_style) }}" alt="{{ icon.label }}" />
        </div>
    {% else if (icon.logo_url || icon.icon_image) { %}
        <div class="icon-container">
            <img class="app-icon" src="{{ icon.logo_url || icon.icon_image }}" alt="{{ icon.label }}" />
        </div>
    {% } else if (icon.icon_type == "Folder") { %}
        <div class="icon-container folder-icon">

        </div>
    {% } else { %}
            {%= frappe.utils.desktop_icon(icon.label, icon.bg_color || "gray") %}
    {% } %}
    {% if (!in_folder) { %}
    <div class="icon-caption">
        <div class="icon-title" data-toggle="tooltip" data-original-title="{{ frappe.utils.escape_html(__(icon.label)) }}">{{ frappe.utils.escape_html(__(icon.label)) }}</div>
        <!-- <div class="icon-subtitle"></div> -->
    </div>
    {% } %}
    {% if(!icon.in_folder && !icon.restrict_removal) { %}
    <div class="hide-button" data-mode="hide">
        {%= frappe.utils.icon("x") %}
    </div>
    {% } %}
</a>
`;
